<script lang="ts">
	import { lazyLoadVideo } from "./lazyLoadVideo.js";
	import type { SourceSetQuery } from "../../utils/SourceSetQuery.js";
	import { sortSourceSetQuery } from "../../utils/sortSourceSetQuery.js";
	import { parseSourceSet } from "../../utils/parseSourceSet.js";

	export let video: string;
	export let width: number | undefined = undefined;
	export let height: number | undefined = undefined;
	export let noLoop = false;
	export let autoplay = true;
	export let controls = false;
	export let muted = false;
	export let playsinline = true;
	export let videoClass = "";
	export let poster: string | undefined = undefined;
	export let lazy = false;
	export let disabled = false;
	export let sourcesets: Partial<Record<SourceSetQuery, string>> = {};

	$: sortedSourcesets = Object.entries(sourcesets).toSorted(([firstQuery], [secondQuery]) =>
		sortSourceSetQuery(firstQuery as SourceSetQuery, secondQuery as SourceSetQuery),
	) as [SourceSetQuery, string][];

	export let element: HTMLVideoElement | null = null;
</script>

<svelte:head>
	{#if !lazy && poster}
		<link rel="preload" as="image" href={poster} fetchpriority="high" type="image/webp" />
	{/if}
</svelte:head>

<video
	bind:this={element}
	use:lazyLoadVideo={{ enabled: lazy, autoplay }}
	autoplay={autoplay && !lazy}
	{height}
	{width}
	loop={!noLoop}
	{muted}
	controls={controls && !disabled}
	{playsinline}
	class="w-full {videoClass}"
	{poster}
	preload={lazy ? "none" : undefined}
>
	{#each sortedSourcesets as [query, video]}
		<source media={parseSourceSet(query)} src="{video}#t=0.001" />
	{/each}

	<source src="{video}#t=0.001" />
</video>
